import { isString } from "../utils/schemaUtils";
import { type GitHubComment, isGitHubComment } from "./githubCommentsSchema";
import { type GitHubDiscussion, isGitHubDiscussion } from "./githubDiscussionsSchema";

// A discussion carries its thread inline, which is how GraphQL serves it, and
// the answer usually lives in a reply rather than the body.
export interface GitHubDiscussionDetail extends GitHubDiscussion {
  type: "github_discussion";
  body?: string;
  comments: GitHubComment[];
  truncated: boolean;
}

export const parseGitHubDiscussionPayload = (v: unknown): GitHubDiscussionDetail | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "github_discussion") return null;
  if (!isGitHubDiscussion(r)) return null;
  if (r.body !== undefined && !isString(r.body)) return null;
  if (!Array.isArray(r.comments) || !r.comments.every(isGitHubComment)) return null;
  if (typeof r.truncated !== "boolean") return null;
  const discussion: GitHubDiscussion = r;
  return {
    ...discussion,
    type: "github_discussion",
    body: r.body,
    comments: r.comments,
    truncated: r.truncated,
  };
};
